import { Box, IconButton } from "@mui/material";
import {
  Facebook as FacebookIcon,
  LinkedIn as LinkedInIcon,
  Instagram as InstagramIcon,
} from "@mui/icons-material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import XIcon from "@mui/icons-material/X"; // Twitter/X

const SocialIcons = () => {
  return (
    <Box sx={{ display: "flex", gap: 1,backgroundColor: "white", padding: 1 }}>
      <IconButton
        component="a"
        href="https://x.com/f_ai2024"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: "#000000",
          "&:hover": { color: "#1DA1F2" },
        }}
      >
        <XIcon />
      </IconButton>

      <IconButton
        component="a"
        href="https://www.facebook.com/profile.php?id=61558618525448"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: "#1877F2",
          "&:hover": { color: "#166FE5" },
        }}
      >
        <FacebookIcon />
      </IconButton>

      <IconButton
        component="a"
        href="https://www.linkedin.com/in/f-ai"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: "#0A66C2",
          "&:hover": { color: "#004182" },
        }}
      >
        <LinkedInIcon />
      </IconButton>

      <IconButton
        component="a"
        href="https://api.whatsapp.com/message/IH3VAQSDYQKZE1?autoload=1&app_absent=0"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: "#25D366",
          "&:hover": { color: "#128C7E" },
        }}
      >
        <WhatsAppIcon />
      </IconButton>

      <IconButton
        component="a"
        href="https://www.instagram.com/f_ai2024/?next=%2F"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: "#E4405F",
          "&:hover": { color: "#C13584" },
        }}
      >
        <InstagramIcon />
      </IconButton>
    </Box>
  );
};

export default SocialIcons;
